import React from 'react';
import { Button } from '../components/ui/Button';
import { ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const deportes = [{
  nombre: 'Fútbol',
  problema: 'El miedo a fallar un penal o perder una pelota clave paraliza al jugador en los momentos decisivos.',
  solucion: 'El Reset de 3 Minutos le permite procesar el error como un dato táctico y volver a la cancha con claridad mental.'
}, {
  nombre: 'Tenis',
  problema: 'La presión de estar solo en la cancha amplifica cada error. Un doble falta puede desmoronar un set completo.',
  solucion: 'El anclaje físico entre puntos le devuelve el control emocional y la concentración punto a punto.'
}, {
  nombre: 'Natación',
  problema: 'La ansiedad pre-competencia genera tensión muscular que afecta directamente los tiempos y la técnica.',
  solucion: 'El protocolo de respiración y Palabra de Poder reduce el cortisol antes de subir al bloque de salida.'
}, {
  nombre: 'Gimnasia',
  problema: 'El perfeccionismo extremo convierte cada pequeño error en una espiral de autocrítica destructiva.',
  solucion: 'El Diario de Victorias Invisibles reconstruye la autoestima basándose en el proceso, no solo en la puntuación.'
}, {
  nombre: 'Básquetbol',
  problema: 'Fallar tiros libres bajo presión o cometer errores frente al equipo genera vergüenza y retraimiento.',
  solucion: 'La técnica de Reset permite soltar el error anterior y enfocarse completamente en la siguiente jugada.'
}, {
  nombre: 'Béisbol',
  problema: 'La espera entre turnos al bat amplifica la ansiedad anticipatoria y el miedo al ponche.',
  solucion: 'El anclaje físico y la rutina pre-turno canalizan la energía nerviosa en concentración productiva.'
}];
export function DeportePage() {
  return <div className="min-h-screen bg-warm-bg font-body text-warm-dark" data-id="element-183">
      {/* Navigation */}
      <nav className="py-6 px-4 border-b border-warm-dark/10" data-id="element-184">
        <div className="max-w-5xl mx-auto flex items-center justify-between" data-id="element-185">
          <a href="#/" className="inline-flex items-center gap-2 text-warm-mid hover:text-warm-dark transition-colors text-sm font-heading uppercase tracking-widest" data-id="element-186">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-187" />
            Volver al inicio
          </a>
          <span className="font-heading font-bold text-warm-dark text-sm tracking-widest uppercase" data-id="element-188">
            Mente de Campeón
          </span>
        </div>
      </nav>

      {/* Hero */}
      <section className="py-24 px-4 bg-warm-bg" data-id="element-189">
        <div className="max-w-3xl mx-auto text-center" data-id="element-190">
          <p className="font-heading tracking-[0.3em] text-xs text-warm-mid uppercase mb-6" data-id="element-191">
            Aplicación por disciplina
          </p>
          <h1 className="text-5xl md:text-6xl font-black text-warm-dark leading-[1.05] mb-8" data-id="element-192">
            UN MÉTODO, TODOS LOS DEPORTES
          </h1>
          <p className="text-lg text-warm-mid max-w-xl mx-auto leading-relaxed" data-id="element-193">
            Las bases de la neuropsicología deportiva son universales. Descubre
            cómo el Método Reset de 3 Minutos se adapta a la disciplina de tu
            hijo.
          </p>
        </div>
      </section>

      {/* Sports Grid */}
      <section className="py-16 px-4 bg-warm-light" data-id="element-194">
        <div className="max-w-5xl mx-auto" data-id="element-195">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-196">
            {deportes.map((deporte, index) => <div key={index} className="py-8 border-b border-warm-dark/10 last:border-b-0 md:last:border-b md:nth-last-child-2:border-b-0" data-id="element-197">
                <div className="flex items-start gap-6" data-id="element-198">
                  <span className="font-heading text-4xl font-black text-warm-dark/15 leading-none shrink-0 w-12" data-id="element-199">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div className="space-y-4" data-id="element-200">
                    <h2 className="text-2xl font-heading font-bold text-warm-dark" data-id="element-201">
                      {deporte.nombre}
                    </h2>
                    <div className="space-y-3 text-sm text-warm-mid leading-relaxed" data-id="element-202">
                      <p data-id="element-203">
                        <span className="text-warm-dark font-medium" data-id="element-204">
                          El problema:
                        </span>{' '}
                        {deporte.problema}
                      </p>
                      <p data-id="element-205">
                        <span className="text-warm-dark font-medium" data-id="element-206">
                          La solución:
                        </span>{' '}
                        {deporte.solucion}
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-4 bg-warm-bg" data-id="element-207">
        <div className="max-w-2xl mx-auto text-center" data-id="element-208">
          <h2 className="text-3xl md:text-4xl font-black text-warm-dark mb-6" data-id="element-209">
            Sin Importar el Deporte, la Mente es la Clave
          </h2>
          <p className="text-warm-mid mb-10 leading-relaxed" data-id="element-210">
            El sistema completo de Mente de Campeón Inquebrantable funciona para
            cualquier disciplina competitiva. Dale a tu hijo la herramienta
            mental que necesita.
          </p>
          <Button onClick={() => {
          trackAddToCart();
          window.open('https://enfoquedeacero.com/cart/44845085818982:1', '_blank');
        }} data-id="element-211">
            Obtener la guía ahora — $6.39
            <ArrowRightIcon className="w-5 h-5" data-id="element-212" />
          </Button>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 text-center text-warm-mid text-sm border-t border-warm-dark/10" data-id="element-213">
        <p data-id="element-214">
          © {new Date().getFullYear()} Mente de Campeón Inquebrantable. Todos
          los derechos reservados.
        </p>
      </footer>
    </div>;
}